import { Column } from 'react-table';
import { Label } from '@britishcouncil/react-admin';

import {
  OnlineSpeakingMonitoringDto,
  OnlineSpeakingMonitoringResult,
  OnlineSpeakingMonitoringStatus,
} from 'api';
import { formatDate } from 'utils';
import { ViewDetailsButton } from 'components';
import { SelectionCell, FollowUpCell } from '../common';
import {
  getOnlineSpeakingMonitoringTypeName,
  getOnlineSpeakingMonitoringResultName,
} from './common';

const getStatusBadge = (status: OnlineSpeakingMonitoringStatus) => {
  switch (status) {
    case OnlineSpeakingMonitoringStatus.Current:
      return <Label color="green">Current</Label>;
    case OnlineSpeakingMonitoringStatus.Archived:
      return <Label color="yellow">Archived</Label>;
    case OnlineSpeakingMonitoringStatus.Deleted:
      return <Label color="red">Deleted</Label>;
    default:
      return null;
  }
};

export const columns: Column<OnlineSpeakingMonitoringDto>[] = [
  {
    Header: ' ',
    id: 'selection',
    width: '50px',
    disableSortBy: true,
    Cell: ({ row }) => (
      <SelectionCell
        row={row}
        isSelectable={(data) => data.status === OnlineSpeakingMonitoringStatus.Current}
        disabledMessage="Only current monitoring records can be deleted"
      />
    ),
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: '110px',
    Cell: ({ value }) => getStatusBadge(value),
  },
  {
    Header: 'Date of monitoring',
    accessor: 'monitoringDate',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Type of monitoring',
    accessor: 'type',
    width: 'auto',
    Cell: ({ value }) => <>{getOnlineSpeakingMonitoringTypeName(value)}</>,
  },
  {
    Header: 'Result of monitoring',
    accessor: 'result',
    width: 'auto',
    Cell: ({ value }) => <>{getOnlineSpeakingMonitoringResultName(value)}</>,
  },
  {
    Header: 'Follow-up completed',
    accessor: 'hasFollowUp',
    width: '150px',
    Cell: ({ row }) => (
      <FollowUpCell
        row={row}
        isDisabled={(data) =>
          data.result === OnlineSpeakingMonitoringResult.Phase0 ||
          data.status !== OnlineSpeakingMonitoringStatus.Current
        }
        disabledMessage="Follow-up cannot be added for this record"
      />
    ),
  },
  {
    Header: 'Details',
    id: 'actions',
    width: '50px',
    Cell: ({ row }) => <ViewDetailsButton to={`${row.original.id}`} />,
    disableSortBy: true,
  },
];
